export enum ESourceType {
    Suburb = 'suburb',
    ClimateZone = 'climateZone',
    Household = 'household',
    Garden = 'garden',
    FireFightingSprinklerSystem = 'fireFightingSprinklerSystem',
    FireFightingFirePumpAndHoses = 'fireFightingFirepumpAndHoses',
    HorseWashdown = 'horseWashdown',
    HorseFloatWashdownSmall = 'horseFloatWashdownSmall',
    HorseFloatWashdownLarge = 'horseFloatWashdownLarge',
    WeedControl = 'weedControl',
    Stock = 'stock',
    OtherUnlicensed = 'otherUnlicensed',
    OtherCrop = 'otherCrop',
    OtherActivity = 'otherActivity',
    Crop = 'crop',
    Activity = 'activity',
}

export enum EPage {
    PropertyLocation = 'PropertyLocation',
    UnlicensedWaterUse = 'UnlicensedWaterUse',
    LicensedWaterUse = 'LicensedWaterUse',
    IndustrialAndCommercial = 'IndustrialAndCommercial',
    TotalWaterUse = 'TotalWaterUse',
}

export interface ISelection {
    name: string
    value: number | string
    suffix?: string
    total: string
    type: ESourceType
    tooltip?: string
}

export interface IActivity {
    name: string
    value: number
    tooltip?: string
}

export interface ISuburb {
    name: string
    zone: string
}

export interface IUserState {
    activitySelections: ISelection[]
    climateZone: ISelection
    cropSelections: ISelection[]
    enabledOptions: string[]
    fireFightingFirePumpAndHoses: ISelection
    fireFightingSprinklerSystem: ISelection
    garden: ISelection
    horseFloatWashdownLarge: ISelection
    horseFloatWashdownSmall: ISelection
    horseWashdown: ISelection
    household: ISelection
    otherActivitySelections: ISelection[]
    otherCropSelections: ISelection[]
    otherUnlicensedSelections: ISelection[]
    stockSelections: ISelection[]
    suburb: ISelection
    weedControl: ISelection
}

export interface IMainPage {
    visible: boolean
}

export interface IPage {
    title: string
    description: string
}

export interface IPage1 extends IPage {
    labelSuburb: string
    labelClimateZone: string
    placeholderSelectSuburb: string
    placeholderSelectClimateZone: string
    tooltipSuburb: string
    tooltipClimateZone: string
}

export interface IPage2 extends IPage {
    buttonAddAnotherOther: string
    buttonAddAnotherStock: string
    headingTotal: string
    labelDescription: string
    labelFireFightingPump: string
    labelFireFightingSprinkler: string
    labelGarden: string
    labelHectaresIrrigated: string
    labelHectaresSprayed: string
    labelHorseFloatWashdownLarge: string
    labelHorseFloatWashdownSmall: string
    labelHorseWashdown: string
    labelHousehold: string
    labelNumberOfDwellings: string
    labelNumberOfResidents: string
    labelOther: string
    labelQuantity: string
    labelStock: string
    labelTotalKilolitresPerAnnum: string
    labelTypeOfStock: string
    labelWashesPerYear: string
    labelWeedControl: string
    placeholderOtherDescription: string
    tooltipFireFightingDwelling: string
    tooltipGarden: string
    tooltipHorseFloatWashdownLarge: string
    tooltipHorseFloatWashdownSmall: string
    tooltipHorseWashdown: string
    tooltipHousehold: string
    tooltipOther: string
    tooltipStock: string
    tooltipWeedControl: string
}

export interface IPage3 extends IPage {
    subheadingIrrigation: string
    labelTypeOfCrop: string
    labelHectaresIrrigated: string
    buttonAddAnotherCrop: string
    labelOther: string
    labelDescription: string
    labelTotalKilolitresPerAnnum: string
    buttonAddAnotherOther: string
    headingTotal: string
    tooltipIrrigation: string
    tooltipOtherCrop: string
    climateZoneNotFound: string
}

export interface IPage4 extends IPage {
    labelTypeOfActivity: string
    labelNumberOfUnits: string
    buttonAddAnotherActivity: string
    labelOther: string
    labelDescription: string
    labelTotalKilolitresPerAnnum: string
    buttonAddAnotherOther: string
    headingTotal: string
    climateZoneNotFound: string
    tooltipOther: string
}

export interface IPage5 extends IPage {
    buttonReducingWaterUseFindOutMore: string
    buttonSellingWaterEntitlementsFindOutMore: string
    descriptionReducingWaterUse: string
    descriptionSellingWaterEntitlements: string
    headingTotal: string
    headingWhatDoIDoNow: string
    linkReducingWaterUseFindOutMore: string
    linkSellingWaterEntitlementsFindOutMore: string
    subheadingIndustrialAndCommercialWaterUse: string
    subheadingLicensedWaterUse: string
    subheadingReducingWaterUse: string
    subheadingSellingWaterEntitlements: string
    subheadingUnlicensedWaterUse: string
    buttonPrint: string
    disclaimer: string
    finalNote: string
}

export interface IMessages {
    page1: IPage1,
    page2: IPage2,
    page3: IPage3,
    page4: IPage4,
    page5: IPage5,
    buttonStartOver: string
    buttonPrevious: string
    buttonNext: string
    buttonStartOverTooltip?: string
    progressTitlePage1: string
    progressTitlePage2: string
    progressTitlePage3: string
    progressTitlePage4: string
    progressTitlePage5: string
}

export interface IFireFighting {
    name: string
    value: number
}

export interface IStock {
    name: string
    value: number
    group: string
}

export interface IGarden {
    name: string
    value: number
}

export interface IMultiplier {
    name: string
    value: number
}
export interface ICrop {
    name: string
    zones: IMultiplier[]
}

export interface IAppState {
    activities: IActivity[]
    crops: ICrop[]
    fireFighting: IFireFighting[]
    garden: IGarden[]
    gardenMax: number
    gardenStep: number
    getTotal: (page: EPage) => string
    horseFloatWashdownLarge: number
    horseFloatWashdownSmall: number
    horseWashdown: number
    household: number
    isCurrentPageComplete: () => boolean
    loaded: boolean
    maxPages: number
    messages: IMessages
    onAddActivity: (text: string) => void
    onAddCrop: (text: string) => void
    onAddOtherActivity: () => void
    onAddOtherCrop: () => void
    onAddOtherUnlicensed: () => void
    onAddStock: React.FormEventHandler<HTMLSelectElement>
    onChangeActivityName: (index: number, text: string) => void
    onChangeActivityValue: (index: number, value: string|number) => void
    onChangeClimateZone: React.FormEventHandler<HTMLSelectElement>
    onChangeCropName: (index: number, text: string) => void
    onChangeCropValue: (index: number, value: string|number) => void
    onChangeFireFightingFirePumpAndHosesValue: React.FormEventHandler<HTMLInputElement>
    onChangeFireFightingSprinklerSystemValue: React.FormEventHandler<HTMLInputElement>
    onChangeGarden: React.FormEventHandler<HTMLInputElement>
    onChangeHorseFloatWashdownLarge: React.FormEventHandler<HTMLInputElement>
    onChangeHorseFloatWashdownSmall: React.FormEventHandler<HTMLInputElement>
    onChangeHorseWashdown: React.FormEventHandler<HTMLInputElement>
    onChangeHousehold: React.FormEventHandler<HTMLInputElement>
    onChangeOtherActivityName: (index: number, value: string) => void
    onChangeOtherActivityValue: (index: number, value: string|number) => void
    onChangeOtherCropName: (index: number, value: string) => void
    onChangeOtherCropValue: (index: number, value: string|number) => void
    onChangeOtherUnlicensedName: (index: number, value: string) => void
    onChangeOtherUnlicensedValue: (index: number, value: string|number) => void
    onChangeStockName: (index: number, value: string) => void
    onChangeStockValue: (index: number, value: string|number) => void
    onChangeSuburb: React.FormEventHandler<HTMLSelectElement>
    onChangeWeedControl: React.FormEventHandler<HTMLInputElement>
    onGotoNamedPage: (page: EPage) => void
    onGotoPage: (newValue: number) => void
    onNextPage: () => void
    onPreviousPage: () => void
    onReset: () => void
    onToggleOption: (key: string, enabled: boolean) => void
    page: number
    stock: IStock[]
    suburbs: ISuburb[]
    userState: IUserState
    weedControl: number
};


interface ISelectionLoose {
    name?: string
    value?: number | string
    suffix?: string
    total?: string
    type: ESourceType
    tooltip?: string
}

export class Selection {
    public static newNumber(data: ISelectionLoose) {
        return {
            name: '',
            total: '',
            value: 0,
            ...data,
        };
    }
    public static newText(data: ISelectionLoose) {
        return {
            name: '',
            total: '',
            value: '',
            ...data,
        };
    }
}


// WEBPACK FOOTER //
// ./src/Types/Model.tsx